import * as angular from 'angular';
import * as _ from 'lodash';

import { Application, ComponentDefinition, Dictionary, GlobalNotification } from '../../models';
import { IApplicationService, IAuthentication, IAuthorizationService, ICurrentApplicationService, IStoreService } from '../../services';
import { jobStarted, Roles } from '../../common';
import { Store, StoreElement } from '../../stateManagement';

class TitleRowController implements angular.IComponentController {
    defaultDatabaseGuid: string;
    displayAdd: string;
    displayName: string;
    doNotTranslate: boolean;
    globalNotification: GlobalNotification;
    hasFailedJobs: boolean;
    isLoading: boolean;
    loadingMessage: string;
    mayGoToTasksPage: boolean;
    mayUpdate: boolean;
    notificationTitle: string;
    userName: string;

    readonly additional: string;
    readonly title: string;

    private _application: Application;
    private _auth: IAuthentication;
    private _garbage: () => void;

    static $inject = [
        '$scope',
        '$state',
        'authorizationService',
        'currentApplicationService',
        'storeService',
        'applicationService'
    ];
    constructor(
        private _$scope: angular.IScope,
        private _$state: angular.ui.IStateService,
        private _authorizationService: IAuthorizationService,
        private _currentApplicationService: ICurrentApplicationService,
        private _storeService: IStoreService,
        private _applicationService: IApplicationService
    ) {
    }

    $onInit() {
        this._$scope.$watch(
            () => this._$state.current,
            () => this.refresh()
        );

        this._$scope.$on(jobStarted, () => {
            this._applicationService
                .getOneWithInformation(this.userName, this._application.guid, null, false)
                .then(data => {
                    this.hasFailedJobs = data.item2.hasFailedJob;
                });
        });

        this._garbage = this._storeService.register(
            store => this.connectToStore(store),
            [StoreElement.Application, StoreElement.Authentication, StoreElement.GlobalNotifications]
        );
    }

    $onChanges(_changesObj: angular.IOnChangesObject) {
        this.refresh();
    }

    $onDestroy() {
        if (this._garbage) {
            this._garbage();
        }
    }

    needUpdate(): boolean {
        const config = this._currentApplicationService.getApplicationConfiguration();
        return config ? !config.defaultDatabaseUpToDate : false;
    }

    private connectToStore(store: Store) {
        const application = store.application.value;
        this.defaultDatabaseGuid = application?.defaultConnectionPointGuid;
        const userRoles=  store.authentication.value.roles;
        this.mayUpdate = this._authorizationService.isInRoles(Roles.updateDatabaseRoles, userRoles);
        this.mayGoToTasksPage = this._authorizationService.isInRoles(Roles.jobsDefinitionRoles, userRoles);
        this.userName = store.authentication.value.userName;
        this._auth = store.authentication.value;
        if (this.userName && application?.guid) {
            this._applicationService
                .getOneWithInformation(this.userName, application.guid, null, false)
                .then(data => {
                    this.hasFailedJobs = data.item2.hasFailedJob;
                });
        }
        this.refreshNotification(store.globalNotifications.dictionary);
        this._application = application;
    }

    private refreshNotification(notifications: Dictionary<GlobalNotification>) {
        const keys = Object.keys(notifications);
        this.globalNotification = (keys.length > 0)
            ? notifications[keys[0]]
            : undefined;
    }

    private refresh() {
        this.displayName = this.title
            ? this.title
            : (this._$state.current.data.displayName ?? this._$state.current.name);

        this.displayAdd = this.additional
            ? ` - ${this.additional}`
            : '';
    }
}

export const wtTitleRow: ComponentDefinition = {
    componentId: 'wtTitleRow',
    controller: TitleRowController,
    template: require('./titleRow.component.html'),
    controllerAs: 'vm',
    transclude: true,
    bindings: {
        title: '<?',
        additional: '<?',
        doNotTranslate: '@?'
    }
};